/* eslint-disable @typescript-eslint/no-unused-vars */
import { Stack, Divider } from "@mantine/core";
import KeyRoles from "./KeyRoles";
import LeftAccountBox from "./LeftAccountBox";
import VisibleTraits from "./VisibleTraits";
import HqAccountTraits from "../../headquarters/components/HqAccountTraits";

type Props = {
  account: any,
  contacts: any
};

const AccountProfileHeader = ({ account, contacts = [] }: Props) => (
  <Stack gap="md" className="w-full p-2">
    {/* Account Box at the top - full width */}
    <LeftAccountBox account={account} />
    
    {/* Visible Traits Section */}
    <div className="w-full">
      <HqAccountTraits account={account} size="xs" withTitle={false} withBorder={false} />
    </div>
    
    {/* Key Roles Section */}
    {account?.external_id && (
      <>
        <Divider label="Key Roles" labelPosition="center" />
          <KeyRoles
            key={account?.external_id}
            accountId={account?.external_id}
            contacts={contacts}
            owner={account?.account_champion_id}
            csm={account?.csm_id}
            ae={account?.ae_id}
            containerClass="w-full h-auto"
            collapsible={false}
            vertical
          />
      </>
    )}
  </Stack>
);
export default AccountProfileHeader;
